<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <b-col
            v-if="hasShowUniversitySelect()"
            md="4"
          >
            <b-form-group
              :label="$t('Education organizations')"
              :label-for="MonitoringReport.ORGANIZATION"
            >
              <v-select
                :id="MonitoringReport.ORGANIZATION"
                v-model="filters[MonitoringReport.ORGANIZATION]"
                :reduce="(option) => option.id"
                :options="universityList"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringReport.DC_TYPE))"
              :label-for="MonitoringReport.DC_TYPE"
            >
              <v-select
                :id="MonitoringReport.DC_TYPE"
                v-model="filters[MonitoringReport.DC_TYPE]"
                multiple
                :reduce="(option) => option.id"
                :options="dcTypes"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="periods.length > 0"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringReport.PERIOD))"
              :label-for="MonitoringReport.PERIOD"
            >
              <v-select
                id="period"
                v-model="filters[MonitoringReport.PERIOD]"
                :options="periods"
                :get-option-label="(option) => option.admission_year"
                :placeholder="$t('All')"
                @input="filters[MonitoringReport.QUARTER] = null"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="filters[MonitoringReport.PERIOD]"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringReport.QUARTER))"
              :label-for="MonitoringReport.QUARTER"
            >
              <v-select
                :id="MonitoringReport.QUARTER"
                v-model="filters[MonitoringReport.QUARTER]"
                :reduce="(option) => option.id"
                :options="filters[MonitoringReport.PERIOD].quarters"
                :get-option-label="(option) => option.quarter"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="periods.length > 0"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringReport.REPORT_PERIOD))"
              :label-for="MonitoringReport.REPORT_PERIOD"
            >
              <v-select
                id="period"
                v-model="filters[MonitoringReport.REPORT_PERIOD]"
                :options="periods"
                :get-option-label="(option) => option.admission_year"
                :placeholder="$t('All')"
                @input="filters[MonitoringReport.REPORT_QUARTER] = null"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="filters[MonitoringReport.REPORT_PERIOD]"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringReport.REPORT_QUARTER))"
              :label-for="MonitoringReport.REPORT_QUARTER"
            >
              <v-select
                :id="MonitoringReport.REPORT_QUARTER"
                v-model="filters[MonitoringReport.REPORT_QUARTER]"
                :reduce="(option) => option.id"
                :options="filters[MonitoringReport.REPORT_PERIOD].quarters"
                :get-option-label="(option) => option.quarter"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringReport.STATUS))"
              :label-for="MonitoringReport.STATUS"
            >
              <v-select
                :id="MonitoringReport.STATUS"
                v-model="filters[MonitoringReport.STATUS]"
                :reduce="(option) => option.id"
                :options="statuses"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringReport.COURSE))"
              :label-for="MonitoringReport.COURSE"
            >
              <v-select
                :id="MonitoringReport.COURSE"
                v-model="filters[MonitoringReport.COURSE]"
                :options="[1, 2, 3]"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              class="mr-1"
              variant="success"
              @click="onFilter"
            >
              <feather-icon icon="LFilterIcon" />
              {{ $t('Filter') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </transition>
</template>

<script>
import vSelect from 'vue-select'
import {
  BButton, BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isObject } from '@core/utils/utils'
import MonitoringReport from '@/views/components/filters/service/MonitoringReport'

export default {
  name: 'FilterComponent',
  components: {
    BForm,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      period: null,
    }
  },
  computed: {
    MonitoringReport() {
      return MonitoringReport
    },
    statuses() {
      return this.$store.state.monitoringReport.statuses
    },
    universityList() {
      return this.$store.state.staticModule.universityList
    },
    dcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
    periods() {
      return this.$store.state.staticModule.periodList
    },
  },
  watch: {
    universityList(newValue) {
      this.changeValue(newValue, MonitoringReport.ORGANIZATION)
    },
    periods(newValue) {
      this.changeValue(newValue, MonitoringReport.PERIOD)
      this.changeValue(newValue, MonitoringReport.REPORT_PERIOD)
      if (this.filters[MonitoringReport.PERIOD]?.quarters) {
        this.changeValue(this.filters[MonitoringReport.PERIOD].quarters, MonitoringReport.QUARTER)
      }
      if (this.filters[MonitoringReport.REPORT_PERIOD]?.quarters) {
        this.changeValue(this.filters[MonitoringReport.REPORT_PERIOD].quarters, MonitoringReport.REPORT_QUARTER)
      }
    },
  },
  created() {
    this.changeValue(this.statuses, MonitoringReport.STATUS)
    if (Array.isArray(this.filters[MonitoringReport.DC_TYPE])) {
      this.filters[MonitoringReport.DC_TYPE] = this.filters[MonitoringReport.DC_TYPE].map(x => Number(x))
    } else if (this.filters[MonitoringReport.DC_TYPE]) {
      this.filters[MonitoringReport.DC_TYPE] = [Number(this.filters[MonitoringReport.DC_TYPE])]
    }
  },
  methods: {
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    changeValue(newValue, field) {
      if (newValue.length && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x.id}` === this.filters[field])
      }
    },
    hasShowUniversitySelect() {
      return this.filterClass.type !== 'monitoringReportOtmItmList' && this.filterClass.type !== 'unmonitored'
    },
  },
  setup() {
  },
}
</script>

<style scoped>

</style>
